<div class="flex flex-col gap-2">
  <barcode-scanner-search-field
    (onSearch)="searchFilter.set($event)"
    (onCode)="codeScanned($event)"
  ></barcode-scanner-search-field>

  @if (api.hasPermission('create_inventory_item')) {
    <p-button
      variant="outlined"
      [label]="'internal.inventory.groupList.newGroup' | translate"
      (onClick)="newGroup()"
      fluid
    >
      <mat-icon>add</mat-icon>
    </p-button>
  }

  <div id="group-list" class="flex flex-col gap-2 rounded-sm bg-neutral-800">
    @if (loadingGroups()) {
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
      <p-skeleton height="2.5rem" />
    } @else {
      @for (group of filteredGroups(); track group) {
        <div class="group flex items-center gap-2 h-10 bg-neutral-700 rounded-sm">
          <div class="font-semibold ml-4">{{ group.name }}</div>
          @if (group.deleted) {
            <div class="text-muted-color">{{ 'internal.inventory.deleted' | translate }}</div>
          }
          <div class="ml-auto flex justify-end items-center gap-2">
            <p-button
              [pt]="{ root: { style: { padding: '4px' } } }"
              [rounded]="true"
              [text]="true"
              [pTooltip]="'internal.inventory.groupList.printGroupLabel' | translate"
              (onClick)="printGroupLabel(group)"
            >
              <mat-icon color="white">print</mat-icon>
            </p-button>
            <p-button
              [pt]="{ root: { style: { padding: '4px' } } }"
              [rounded]="true"
              [text]="true"
              [pTooltip]="'internal.inventory.groupList.printItemLabel' | translate"
              (onClick)="printItemLabels(group)"
            >
              <mat-icon color="white">summarize</mat-icon>
            </p-button>
            <p-button
              [pt]="{ root: { style: { padding: '4px' } } }"
              [rounded]="true"
              [text]="true"
              (onClick)="showGroup(group)"
            >
              <mat-icon color="white">visibility</mat-icon>
            </p-button>
          </div>
        </div>
      } @empty {
        <empty-state
          [icon]="'search_off'"
          [title]="'internal.inventory.groupList.empty.title' | translate"
          [subtitle]="'internal.inventory.groupList.empty.subtitle' | translate"
          [showButton]="true"
          [buttonText]="'internal.inventory.groupList.empty.button' | translate"
          (buttonClick)="resetScannerField()"
        >
        </empty-state>
      }
    }
  </div>
</div>

<div class="flex justify-end gap-2 mt-4">
  <p-button
    [label]="'general.close' | translate"
    severity="secondary"
    (onClick)="dialogRef.close()"
  />
</div>
